module.exports = __webpack_public_path__ + "h5/img/noActivity.c3670d45.png";